'use strict';

const supportedLang = ['en'];
var supportedLangData = [];
import * as utils from './utils';

import en from '../templates/data/en/data.json';
//import es from '../templates/data/data-es.json';

// es importante el orden coincida con "supportedLang"
supportedLangData.push(en);
//supportedLangData.push(es);

var compiled = require('../templates/template.hbs'); //https://github.com/emaphp/handlebars-template-loader
var compiledPages = [];
// Get Handlebars instance
var Handlebars = require('handlebars-template-loader/runtime');

// Register partial
Handlebars.registerPartial('header', require('../templates/header.hbs'));
Handlebars.registerPartial('footer', require('../templates/footer.hbs'));

Handlebars.registerPartial('home', require('../templates/pages/home.hbs'));
Handlebars.registerPartial('why_rs', require('../templates/pages/why_rs.hbs'));
Handlebars.registerPartial('why_la', require('../templates/pages/why_la.hbs'));
Handlebars.registerPartial('our_services', require('../templates/pages/our_services.hbs'));
Handlebars.registerPartial('about_us', require('../templates/pages/about_us.hbs'));
Handlebars.registerPartial('candidate_appl_form', require('../templates/pages/forms/candidate_appl_form.hbs'));
Handlebars.registerPartial('investigator_appl_form', require('../templates/pages/forms/investigator_appl_form.hbs'));
Handlebars.registerPartial('contact_us', require('../templates/pages/contact_us.hbs'));
Handlebars.registerPartial('test', require('../templates/pages/test.hbs'));

Handlebars.registerPartial('list', require('../templates/components/list.hbs'));
Handlebars.registerPartial('slider', require('../templates/components/slider.hbs'));
Handlebars.registerPartial('map', require('../templates/components/map.hbs'));
Handlebars.registerPartial('form', require('../templates/components/forms/form.hbs'));



Handlebars.registerHelper('ifCond', function(v1, v2, options) {
  if(v1 === v2) {
    return options.fn(this);
  }
  return options.inverse(this);
});

Handlebars.registerPartial('form-validation', require('../templates/components/forms/form-validation.hbs'));
Handlebars.registerPartial('form-input', require('../templates/components/forms/form-input.hbs'));

export default function templates(lang, callback) {
	var data = compiled(supportedLangData[0]);

	document.querySelector("html").setAttribute("lang", supportedLang[0]);

	if (DEBUG) {
		if (DEBUG === "css") {
			document.querySelector("html").classList.add("debug");
		}
		data += '<div class="debug-tree"><div class="content-wrapper"><div class="border"></div></div></div>';
	}

	document.querySelector('#web-container').innerHTML = data;

	if (callback) {
		callback();
	}
};



//////////////////
// WEBPACK FOOTER
// ./src/js/templates.js
// module id = 16
// module chunks = 0